var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackmarketTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 83,
    viewBox: "0 0 180 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9278 54.4912H35.1747L35.1292 55.2429L34.4738 66.0666H31.0155L34.424 16.8H40.5084L44.1471 66.0666H40.0918L39.3859 55.2392L39.3372 54.4912H38.5876H35.9278ZM38.1737 35.6736L38.1287 34.9215H37.3752H37.1966H36.4465L36.3983 35.67L35.6034 48.0026L35.5485 48.8541H36.4017H38.1137H38.963L38.9122 48.0063L38.1737 35.6736Z",
    stroke: "white",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7373 40.4629L70.7154 40.5916L70.7356 40.7206L74.7063 66.0666H70.8337L68.2013 50.1444L68.0906 49.4749H67.412H67.2925H66.4925V50.2749V66.0666H62.1887V16.8H66.4925V33.9021V34.7021H67.2925H67.412H68.0943L68.202 34.0284L70.9556 16.8H74.7532L70.7373 40.4629Z",
    stroke: "white",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4398 59.6294V60.4294H21.2398H28.6408L28.256 66.0666H26.0708H16.1359V59.6294V16.8H20.4398V59.6294Z",
    stroke: "white",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8264 60.4603H54.6264V59.6603V58.1337V45.829H58.9303V59.2253V66.0666H53.5284H50.5503H46.9328V41.4333V16.8H50.5503H53.5284H58.9303V23.6413V37.0375H54.6264V24.7329V23.2076V22.4076H53.8264H52.038H51.238V23.2076V41.4333V59.6603V60.4603H52.038H53.8264Z",
    stroke: "white",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3119 38.5705L96.9878 66.0813H94.2266L92.0192 38.5738L91.9601 37.8378H91.2217H91.1022H90.3022V38.6378V66.0813H86.9504V16.8H93.0219L94.8564 31.109L96.4436 31.1075L98.2498 16.8H104.32V66.0813H101.029V38.6378V37.8378H100.229H100.109H99.3738L99.3119 38.5705Z",
    stroke: "white",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.038 40.4629L147.016 40.5916L147.036 40.7206L151.007 66.0666H147.134L144.502 50.1444L144.391 49.4749H143.713H143.593H142.793V50.2749V66.0666H138.489V16.8H142.793V33.9021V34.7021H143.593H143.713H144.395L144.503 34.0284L147.256 16.8H151.054L147.038 40.4629Z",
    stroke: "white",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.049 54.4912H111.296L111.25 55.2429L110.595 66.0666H107.137L110.545 16.8H116.63L120.268 66.0666H116.213L115.507 55.2392L115.458 54.4912H114.709H112.049ZM114.295 35.6736L114.25 34.9215H113.496H113.318H112.568L112.519 35.67L111.724 48.0026L111.67 48.8541H112.523H114.235H115.084L115.033 48.0063L114.295 35.6736Z",
    stroke: "white",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.278 60.8271V61.6271H159.078H163.705V66.0666H153.974V16.8H156.038H163.722V22.5083H159.078H158.278V23.3083V37.7785V38.5785H159.078H163.705V44.2881H159.078H158.278V45.0881V60.8271Z",
    stroke: "white",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.709 23.3083V22.5083H169.909H166.534V22.0394V16.8H179.199V22.5083H175.813H175.013V23.3083V66.0666H170.709V23.3083Z",
    stroke: "white",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.242 44.3458H127.442V45.1458V66.0666H123.138V16.8H133.378H135.134V37.5399L132.746 40.9768L132.429 41.4333L132.746 41.8898L135.134 45.3266V66.0666H130.83V45.1458V44.3458H130.03H128.242ZM130.83 23.2076V22.4076H130.03H128.242H127.442V23.2076V37.7073V38.5073H128.242H130.03H130.83V37.7073V23.2076Z",
    stroke: "white",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4095 40.9768L10.0923 41.4333L10.4095 41.8898L12.7974 45.3266V66.0666H0.8V16.8H11.0396H11.041H12.7974V37.5399L10.4095 40.9768ZM8.49363 23.2076V22.4076H7.69363H5.90516H5.10516V23.2076V37.7073V38.5073H5.90516H7.69363H8.49363V37.7073V23.2076ZM5.10382 59.1568V59.9568H5.90382H7.69228H8.49228V59.1568V45.1458V44.3458H7.69228H5.90382H5.10382V45.1458V59.1568Z",
    stroke: "white",
    strokeWidth: 1.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3436 66.8666H45.0084L41.2515 16H33.6774L30.1582 66.8666H35.2269L35.9278 55.2912H38.5876L39.3422 66.8666H39.3436ZM37.3752 35.7215L38.1137 48.0541H36.4017L37.1966 35.7215H37.3752Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.526 40.5968L75.6414 66.8666H70.1551L67.412 50.2749H67.2925V66.8666H61.3887V16H67.2925V33.9021H67.412L70.2733 16H75.7004L71.526 40.5968Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2398 59.6294V16H15.3359V59.6294V66.8666H26.0708H29.0032L29.4973 59.6294H21.2398Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5284 16H50.5503H46.1328V41.4333V66.8666H50.5503H53.5284H59.7303V59.2253V45.029H53.8264V58.1337V59.6603H52.038V41.4333V23.2076H53.8264V24.7329V37.8375H59.7303V23.6413V16H53.5284Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5445 16H105.12V66.8813H100.229V38.6378H100.109L97.7231 66.8813H93.4882L91.2217 38.6378H91.1022V66.8813H86.1504V16H93.7259L95.6499 31.0073L97.5445 16Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.827 40.5968L151.942 66.8666H146.456L143.713 50.2749H143.593V66.8666H137.689V16H143.593V33.9021H143.713L146.574 16H152.001L147.827 40.5968Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.465 66.8666H121.129L117.373 16H109.798L106.279 66.8666H111.348L112.049 55.2912H114.709L115.463 66.8666H115.465ZM113.496 35.7215L114.235 48.0541H112.523L113.318 35.7215H113.496Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M164.52 23.3083V16H164.026H156.036H153.172V66.8666H164.503V60.8271H159.076V45.0881H164.503V37.7785H159.076V23.3083H164.52Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.987 16H165.734V22.0394V23.3083H169.909V66.8666H175.813V23.3083H179.999V16H179.987Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.378 16H122.338V66.8666H128.242V45.1458H130.03V66.8666H135.934V45.076L133.403 41.4333L135.934 37.7906V16H133.378ZM130.03 23.2076V37.7073H128.242V23.2076H130.03Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0396 16H0V66.8666H13.5974V45.076L11.0665 41.4333L13.5974 37.7906V16H11.041H11.0396ZM7.69363 23.2076V37.7073H5.90516V23.2076H7.69363ZM5.90382 59.1568V45.1458H7.69228V59.1568H5.90382Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackmarketTitle);
export default __webpack_public_path__ + "static/media/blackmarket-title.7eff326eda72ea5cb6f13082ed289bce.svg";
export { ForwardRef as ReactComponent };